"use client";

import { useTranslations } from "next-intl";
import { processStepKeys } from "@/lib/brand";
import { MegaMenu } from "./MegaMenu";
import { IllustrationVisual } from "./IllustrationVisual";
import { processStepIllustrations } from "./illustrations/processStepIllustrations";

/** "How we work" mega menu — one illustrated card per process step. */
export function ProcessMegaMenu() {
  const t = useTranslations("header");
  const tProcess = useTranslations("process");
  return (
    <MegaMenu
      label={t("nav.process")}
      items={processStepKeys.map((key) => {
        const Illustration = processStepIllustrations[key];
        return {
          key,
          href: "#process",
          visual: (
            <IllustrationVisual>
              <Illustration />
            </IllustrationVisual>
          ),
          title: tProcess(`steps.${key}.title`),
          detail: tProcess(`steps.${key}.detail`),
          cta: t("processCta"),
        };
      })}
    />
  );
}
